import React, { useState, useEffect } from "react";
import { object, array, string } from "prop-types";
import { LazyCollection, LazyLoadImages, Link } from "@quintype/components";
import { connect } from "react-redux";
import get from "lodash/get";

import { getCollectionTemplate } from "../../get-collection-template";
import HeaderWrapper from "../../header/header-wrapper";
import { getSectionsDataForHeader, getDomainSectionInfo, getMultiDomainMenuData } from "../../utils/utils";
import Headline from "../../atoms/Headline";
import SixteenStories1WidgetWithPollAndLoadMore from "../../rows/SixteenStories1WidgetWithPollAndLoadMore";
import SixteenStories3AdWithTagSearchAndLoadMore from "../../rows/SixteenStories3AdWithTagSearchAndLoadMore";

import "./section.m.css";

const SectionPageBase = props => {
  const {
    data: { collection },
    sections,
    domainSlug,
    protichintaMenuItems,
    trustMenuItems,
    kishoraloMenuItems,
    bondhushavaMenuItems,
    bigganChintaMenuItems,
    prothomaloMenuItems,
    nagorikMenuItems,
    publisherAttributes
  } = props;
  const [domainStyleName, setDomainStyleName] = useState("");
  const [domainSectionObj, setSectionDomainObj] = useState({});
  const sectionsDataForHeader =
    collection.template !== "default" &&
    getSectionsDataForHeader(sections, domainSlug, collection.metadata.section, domainSectionObj);
  const stories = collection.items.filter(item => item.type === "story");
  const collectionSlug = collection.slug;
  const widgetUrl = get(collection, ["metadata", "section-page-widget-url"], null);

  useEffect(() => {
    setSectionDomainObj(getDomainSectionInfo(domainSlug, sections));
    switch (domainSlug) {
      case "kishoralo":
        return setDomainStyleName("kishoralo-section");
      case "protichinta":
        return setDomainStyleName("protichinta-section");

      default:
        return setDomainStyleName("");
    }
  }, [domainSlug]);

  const getMultiDomainMenuItems = getMultiDomainMenuData(
    domainSlug,
    protichintaMenuItems,
    trustMenuItems,
    kishoraloMenuItems,
    bondhushavaMenuItems,
    bigganChintaMenuItems,
    prothomaloMenuItems,
    nagorikMenuItems
  );
  const getMenuItems = props.domainSlug ? getMultiDomainMenuItems : prothomaloMenuItems;
  const menuItemsObject = getMenuItems.length > 0 ? getMenuItems.filter(item => item.title === "sections") : null;
  const sectioPageMenuItems = menuItemsObject && menuItemsObject.length > 0 ? menuItemsObject[0].children : null;

  const parentSectionMenuItem =
    sectioPageMenuItems && sectioPageMenuItems.length > 0
      ? sectionsDataForHeader && sectionsDataForHeader.parentSection
        ? domainSlug && `https://${domainSlug}.qtstage.io/` === sectionsDataForHeader.parentSectionUrl
          ? sectioPageMenuItems.find(item => item.completeUrl === sectionsDataForHeader.currentSectionUrl)
          : sectioPageMenuItems.find(item => item.completeUrl === sectionsDataForHeader.parentSectionUrl)
        : sectioPageMenuItems.find(item => item.completeUrl === sectionsDataForHeader.currentSectionUrl)
      : null;

  // Renders the menu items of the section
  const childSectionsDom = () => {
    return (
      <ul
        styleName={`sub-sections ${publisherAttributes.lang === "en" ? "en-sub-sections" : ""}`}
        className="sub-sections"
      >
        {sectionsDataForHeader.childSections.slice(0, 12).map((item, index) => (
          <li
            styleName="section"
            className={sectionsDataForHeader.currentSection === item["display-name"] ? "current-section" : ""}
            key={index}
          >
            <Link href={item["section-url"]}>{item["display-name"]}</Link>
          </li>
        ))}
      </ul>
    );
  };

  const getBigSectionName = () => {
    if (
      (domainSlug && sectionsDataForHeader.parentSectionId !== domainSectionObj.id) ||
      (sectionsDataForHeader.parentSection && !domainSlug)
    ) {
      return (
        <Link href={sectionsDataForHeader.parentSectionUrl}>
          <Headline
            headerLevel={1}
            headlineType={9}
            text={sectionsDataForHeader.parentSection}
            styleName={`${publisherAttributes.lang}-section-name`}
          />
        </Link>
      );
    } else {
      return (
        <Link href={sectionsDataForHeader.currentSectionUrl}>
          <Headline
            headerLevel={1}
            headlineType={9}
            text={sectionsDataForHeader.currentSection}
            styleName={`${publisherAttributes.lang}-section-name`}
          />
        </Link>
      );
    }
  };

  const getSmallSectionName = () => {
    if (domainSlug && sectionsDataForHeader.parentSectionId === domainSectionObj.id) {
      return null;
    }
    return sectionsDataForHeader.parentSection ? (
      <Link href={sectionsDataForHeader.currentSectionUrl}>
        <Headline headerLevel={2} headlineType={4} text={sectionsDataForHeader.currentSection} />
      </Link>
    ) : null;
  };

  const defaultCollectionName = () => (
    <div
      id="section-meta-wrapper"
      styleName={`section-meta-wrapper ${domainStyleName}`}
      className="section-meta-wrapper"
    >
      <div styleName="section-headers">
        <Headline
          headerLevel={1}
          headlineType={9}
          text={collection.name}
          styleName={`${publisherAttributes.lang}-collection-name`}
        />
      </div>
    </div>
  );

  const sectionWithMenuItems = () => (
    <div
      id="section-meta-wrapper"
      styleName={`section-meta-wrapper ${domainStyleName}`}
      className="section-meta-wrapper"
    >
      <div styleName="section-headers" className="section-headers">
        {getBigSectionName()}
        {getSmallSectionName()}
      </div>
      {childSectionsDom()}
    </div>
  );

  const currentSubSection =
    parentSectionMenuItem && parentSectionMenuItem.children.length > 0
      ? parentSectionMenuItem.children.find(item => item.completeUrl === sectionsDataForHeader.currentSectionUrl)
      : null;

  const sectionMenuDom = () => (
    <div
      id="section-meta-wrapper"
      styleName={`section-meta-wrapper ${domainStyleName}`}
      className="section-meta-wrapper"
    >
      <div styleName="section-headers" className="section-headers">
        <Link href={parentSectionMenuItem.completeUrl}>
          <Headline headerLevel={1} headlineType={9} text={parentSectionMenuItem.title} />
        </Link>
        {currentSubSection && sectionsDataForHeader.parentSection && (
          <Link href={currentSubSection.completeUrl}>
            <Headline
              headerLevel={2}
              headlineType={4}
              text={currentSubSection.title}
              styleName={`${publisherAttributes.lang}-section-name`}
            />
          </Link>
        )}
      </div>
      {parentSectionMenuItem.children.length > 0 && (
        <ul
          styleName={`sub-sections ${publisherAttributes.lang === "en" ? "en-sub-sections" : ""}`}
          className="sub-sections"
        >
          {parentSectionMenuItem.children.slice(0, 12).map((item, index) => (
            <li
              styleName="section"
              className={sectionsDataForHeader.currentSectionUrl === item.completeUrl ? "current-section" : ""}
              key={index}
            >
              {item.completeUrl === "/#" ? (
                <span>{item.title}</span>
              ) : (
                <Link href={item.completeUrl}>{item.title}</Link>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );

  return (
    <React.Fragment>
      <HeaderWrapper />
      {parentSectionMenuItem
        ? sectionMenuDom()
        : collection.template === "default"
        ? defaultCollectionName()
        : sectionWithMenuItems()}
      <div>
        {collection["data-source"] === "automated" &&
        (collection.template === "default" || collection.template === "section") ? (
          !stories.length ? (
            <div styleName={`no-section-stories ${publisherAttributes.lang === "en" ? "en-no-stories" : ""}`}>
              No stories found for this section !!
            </div>
          ) : (
            <div>
              {sectionsDataForHeader.parentSection ? (
                <SixteenStories1WidgetWithPollAndLoadMore
                  collectionSlug={collectionSlug}
                  stories={stories}
                  widgetUrl={widgetUrl}
                />
              ) : (
                <SixteenStories3AdWithTagSearchAndLoadMore
                  collectionSlug={collectionSlug}
                  stories={stories}
                  widgetUrl={widgetUrl}
                />
              )}
            </div>
          )
        ) : !collection.items.length ? (
          <div styleName={`no-section-stories ${publisherAttributes.lang === "en" ? "en-no-stories" : ""}`}>
            No stories found for this section !!
          </div>
        ) : (
          <LazyLoadImages>
            <LazyCollection collection={collection} collectionTemplates={getCollectionTemplate} lazyAfter={2} />
          </LazyLoadImages>
        )}
      </div>
    </React.Fragment>
  );
};

SectionPageBase.propTypes = {
  data: object,
  sections: array,
  pageType: string,
  menu: array,
  domainSlug: string,
  prothomaloMenuItems: array,
  protichintaMenuItems: array,
  bigganChintaMenuItems: array,
  bondhushavaMenuItems: array,
  trustMenuItems: array,
  kishoraloMenuItems: array,
  nagorikMenuItems: array,
  publisherAttributes: object
};

const mapStateToProps = state => {
  return {
    menu: get(state, ["qt", "data", "navigationMenu"], []),
    sections: get(state, ["qt", "config", "sections"], []),
    pageType: get(state, ["qt", "pageType"], ""),
    domainSlug: get(state, ["qt", "domainSlug"], ""),
    prothomaloMenuItems: get(state, ["qt", "data", "navigationMenu", "prothomaloMenuItems"], []),
    protichintaMenuItems: get(state, ["qt", "data", "navigationMenu", "protichintaMenuItems"], []),
    bigganChintaMenuItems: get(state, ["qt", "data", "navigationMenu", "bigganChintaMenuItems"], []),
    bondhushavaMenuItems: get(state, ["qt", "data", "navigationMenu", "bondhushavaMenuItems"], []),
    trustMenuItems: get(state, ["qt", "data", "navigationMenu", "trustMenuItems"], []),
    kishoraloMenuItems: get(state, ["qt", "data", "navigationMenu", "kishoraloMenuItems"], []),
    nagorikMenuItems: get(state, ["qt", "data", "navigationMenu", "nagorikMenuItems"], []),
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {})
  };
};

export const SectionPage = connect(mapStateToProps, null)(SectionPageBase);
